<template>
  <omint-page-content>
    <omt-highlight>Selecione os beneficiários:</omt-highlight>
    <SwitchCheckBox
      v-for="b in beneficiarios"
      :key="b.Sequencia"
      :onChange="val => setBeneficiario(b.Sequencia, val)"
      :rounded="true"
    >
      <label> {{ b.Nome }}. </label>
    </SwitchCheckBox>
    <br />
    <omt-buttons-bar>
      <omt-button :disabled="selecionados.length === 0" :onClick="gerar"> Gerar </omt-button>
    </omt-buttons-bar>
    <br />
  </omint-page-content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import SwitchCheckBox from "@/components/Molecules/SwitchCheckBox";

export default {
  name: "DrOmintPreform",
  components: { SwitchCheckBox },
  async mounted() {
    await this.$root.$emit("show-loading");
    try {
      this.$root.$emit("change-title-label", "Voucher Vacina");
      if (this.beneficiarios.length === 0) {
        await this.fetchBeneficiarios();
      }
    } finally {
      await this.$root.$emit("hide-loading");
    }
  },
  data() {
    return {
      selecionados: []
    };
  },
  computed: {
    ...mapState("saude", ["route"]),
    ...mapState("voucher", ["beneficiarios"]),
    isMobile() {
      const android = navigator.userAgent.match(/Android/i);
      const iPhone = navigator.userAgent.match(/iPhone|iPad|iPod/i);
      const windowsPhone = navigator.userAgent.match(/IEMobile/i);
      return android || iPhone || windowsPhone;
    }
  },
  methods: {
    ...mapActions("voucher", ["fetchBeneficiarios", "createVoucher"]),
    async setBeneficiario(sequencia, valor) {
      if (valor) {
        this.selecionados.push(sequencia);
      } else {
        this.selecionados = this.selecionados.filter(s => s !== sequencia);
      }
    },
    async gerar() {
      await this.$root.$emit("show-loading");
      let url = "";
      try {
        url = await this.createVoucher({
          beneficiarios: this.selecionados
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }
      if (url === "") {
        await Swal.fire({
          title: "Erro",
          text: "Não foi possivel gerar o voucher.\nServiço temporariamente indisponível.",
          confirmButtonText: "OK",
          icon: "error"
        });
      } else {
        if (this.isMobile) {
          window.location = url;
        } else {
          window.open(url, "_blank");
        }
        await this.$router.push(this.route);
      }
    }
  }
};
</script>
